import { Construction, SearchX } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, EmptyState, PageHeader } from '../components/ui/display';

const PHASES: Record<number, string> = {
  2: 'Phase 2 — Marketing expenses, GST calculation, morning data entry and missing-data detection',
  3: 'Phase 3 — Revenue entries, currency conversion and revenue reports',
  4: 'Phase 4 — Other expenses and profit/loss',
  5: 'Phase 5 — Daily, monthly, yearly, app, marketing and revenue reports',
  6: 'Phase 6 — GST dashboard, claim periods, invoices, audit viewer and exports',
};

/** Page shown for navigation items that arrive in a later phase. */
export function ComingSoonPage({ title, phase }: { title: string; phase: number }) {
  return (
    <>
      <PageHeader title={title} />
      <Card>
        <EmptyState
          icon={<Construction className="size-6" />}
          title={`${title} arrives in phase ${phase}`}
          description={PHASES[phase]}
        />
      </Card>
    </>
  );
}

export function NotFoundPage() {
  return (
    <Card>
      <EmptyState
        icon={<SearchX className="size-6" />}
        title="Page not found"
        description="The page you are looking for does not exist."
        action={
          <Link to="/">
            <Button variant="secondary">Back to dashboard</Button>
          </Link>
        }
      />
    </Card>
  );
}
